export function getLabel(patients) {
  if (patients.length === 0) {
    return 'Patient'
  } else {
    return patients.map(patient => patient.first_name).join(', ')
  }
}
